import { Col, InputGroup, Row } from 'react-bootstrap';
import GenericButton from 'src/Components/GenericButton/GenericButton';
import TextInput from 'src/Components/GenericInputText/TextInput';
import { SearchSVG } from 'src/Member/img/GlobalSVG';
import AutoSuggestionSelectComponent from 'src/Member/components/common/auto-suggestion-select/Select';
import './MessagingScreen.scss';
import MessagingParent from './MessagingParent';
import CustomClientError from 'src/Member/errorhandling/CustomClientError';
import { useEffect, useState } from 'react';

function MessagingFiltersScreen({
  sortByData,
  searchText,
  typeData,
  SortByDummyOptions,
  setSortByData,
  setTypeData,
  AttachmentOptions,
  attachmentData,
  setAttachmentData,
  onSearch,
  resetFilterHandler,
  isComposing,
  setIsComposing,
  replyEnabled,
  setReplyEnabled,
  listApiServerError,
  listApiDataNotFoundError,
  listLoading,
  filteredData,
  totalRecords,
  pageSize,
  currentPage,
  displayPaginationMininumCount,
  pageSizeHandler,
  paginationHandler,
  selectedTab,
  setSelectedTab,
  setSelectedIndex,
  selectedIndex,
  setSelectedIndexForSent,
  selectedIndexForSent,
  messageSelectedFromPopup,
  messageDetailData,
  setMessageDetailData,
  typeOptionList,
  setCurrentPage,
  getSanitizedContent,
  downloadFileHandler,
  downloadAllFileHandler,
  setIsComposed,
  markeMessageAsRead,
}) {
  const [dataList, setDataList] = useState([]);
  const [totalRecordsData, setTotalRecordsData] = useState(totalRecords);

  useEffect(() => {
    setDataList(filteredData);
    setTotalRecordsData(totalRecords);
  }, [filteredData]);

  return (
    <div className="for_messaging">
      <div className="messaging-filter-container filter-bar-border-top filter-bar-border-bottom mt-2 mb-md-4 mb-xs-3">
        <div className="container-offset">
          <Row className="">
            <Col lg={2} md={2} className="Sort_by_option px-0 py-3 ml-3">
              <div className="filter-data1 d-flex gap-3 align-items-center">
                <div>
                  <span className="dropdown_label">Sort By:</span>
                </div>
                <div>
                  <AutoSuggestionSelectComponent
                    options={SortByDummyOptions}
                    components={{ IndicatorSeparator: () => null }}
                    value={sortByData}
                    onChange={(e) => {
                      setSortByData(e);
                    }}
                    isSearchable={false}
                    inputClassName="height-32"
                    aria-labelledby="forsortby"
                  />
                </div>
              </div>
            </Col>
            <Col
              xs={12}
              sm={6}
              md={3}
              lg={3}
              className="ml-1 border-right-documents py-3"
            >
              <label htmlFor="filterByTitleReference" className="sr-only">
                By Title or Description
              </label>
              <TextInput
                parentClassName="document-search"
                append={
                  <InputGroup.Text>
                    <SearchSVG.SearchSVG className="primary-text-color" />
                  </InputGroup.Text>
                }
                inputProps={{
                  type: 'text',
                  placeholder: 'By Title or Description',
                  className: 'border-right-0 height-32',
                  value: searchText,
                  onChange: onSearch,
                  id: 'filterByTitleReference',
                }}
              />
            </Col>
            <Col lg={2} md={2} className="Sort_by_option px-0 py-3">
              <div className="filter-data1 d-flex gap-3 align-items-center">
                <div>
                  <span className="dropdown_label">Type:</span>
                </div>
                <div>
                  <AutoSuggestionSelectComponent
                    options={typeOptionList}
                    components={{ IndicatorSeparator: () => null }}
                    value={typeData}
                    onChange={(e) => {
                      setCurrentPage(1);
                      setTypeData(e);
                    }}
                    isSearchable={false}
                    inputClassName="height-32"
                    aria-labelledby="forsortby"
                  />
                </div>
              </div>
            </Col>
            <Col lg={2} md={2} className="Sort_by_option px-0 py-3">
              <div className="filter-data1 d-flex gap-3 align-items-center">
                <div>
                  <span className="dropdown_label">Attachments:</span>
                </div>
                <div>
                  <AutoSuggestionSelectComponent
                    options={AttachmentOptions}
                    components={{ IndicatorSeparator: () => null }}
                    value={attachmentData}
                    onChange={(e) => {
                      setCurrentPage(1);
                      setAttachmentData(e);
                    }}
                    isSearchable={false}
                    inputClassName="height-32"
                    aria-labelledby="forsortby"
                  />
                </div>
              </div>
            </Col>
            <Col className="compose-msg-button py-3 px-0">
              <div className="d-flex align-items-center justify-content-end">
                <div
                  className="messaging-reset pr-4"
                  onClick={() => resetFilterHandler()}
                >
                  Reset Filter
                </div>
                {/*<div>
                  <GenericButton
                    variant="secondary"
                    onClick={() => {
                      setIsComposing(true);
                      setReplyEnabled(false);
                    }}
                  >
                    COMPOSE MESSAGE
                  </GenericButton>
                </div> */}
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <div className="container-offset">
        {listApiServerError ? (
          <CustomClientError
            ErrorHeading={
              listApiDataNotFoundError
                ? 'No result found!'
                : 'Something went wrong with request!'
            }
            ErrorMessage={
              listApiDataNotFoundError
                ? 'No result found with the selected filters, Please try again'
                : 'Please try again.'
            }
          />
        ) : (
          <MessagingParent
            isComposing={isComposing}
            setIsComposing={setIsComposing}
            replyEnabled={replyEnabled}
            setReplyEnabled={setReplyEnabled}
            listLoading={listLoading}
            data={dataList}
            totalRecords={totalRecordsData}
            pageSize={pageSize}
            currentPage={currentPage}
            displayPaginationMininumCount={displayPaginationMininumCount}
            pageSizeHandler={pageSizeHandler}
            paginationHandler={paginationHandler}
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
            setSelectedIndex={setSelectedIndex}
            selectedIndex={selectedIndex}
            setSelectedIndexForSent={setSelectedIndexForSent}
            selectedIndexForSent={selectedIndexForSent}
            messageSelectedFromPopup={messageSelectedFromPopup}
            messageDetailData={messageDetailData}
            setMessageDetailData={setMessageDetailData}
            getSanitizedContent={getSanitizedContent}
            downloadFileHandler={downloadFileHandler}
            downloadAllFileHandler={downloadAllFileHandler}
            setIsComposed={setIsComposed}
            markeMessageAsRead={markeMessageAsRead}
          />
        )}
      </div>
    </div>
  );
}

export default MessagingFiltersScreen;
